import { SEARCH_ALLOWEDLIST } from "../actions/types";

const initialState = {
  allowedList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SEARCH_ALLOWEDLIST:
      return {
        ...state,
        allowedList: action.payload,
      };
    default:
      return state;
  }
}
